import upgradeDark from './images/upgrade-dark.png';
import upgradeLight from './images/upgrade-light.png';

export const trialAssets = {
    upgrade: { light: upgradeLight, dark: upgradeDark },
} as const;
